import axios from "axios";

// Backend API URL from .env (CRA requires REACT_APP_ prefix)
// Example: REACT_APP_API_BASE_URL=https://api.floodsrp.org/api
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3020/api";

// Origin without /api - useful for static /uploads paths
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "");

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage on each request
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, redirect to login
      localStorage.removeItem("accessToken");
      localStorage.removeItem("currentUser");
      // window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
